module.exports = __webpack_public_path__ + "static/img/img11.a9d0e2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pic/img11.png
// module id = poj2
// module chunks = 0